export default {
  error: {
    FORBIDDEN: '許可されていない操作です。',
    CODE_MISMATCH_EXCEPTION: 'コードは正しくありません。',
    EXPIRED_CODE_EXCEPTION: '@:error.CODE_MISMATCH_EXCEPTION',
    ANSWER_LOCK_CONFLICT_EXCEPTION: '@:upload_common.unable_edit_someone_editing_survey',
    ZERO_IS_NOT_AllOWED_EXCEPTION: '@:validation.invalid_zero_number',
    COMPARISON_MISSING_EXCEPTION: '指定された範囲内で数値を入力してください',
    ESG_DATA_ANSWER_GROUP_VERSIONS_NOT_FOUND: '選択したテンプレートが見つかりませんでした',
    ESG_DATA_NAME_DUPLICATE_EXCEPTION: 'データ名が重複しているので登録できませんでした',
    ESG_DATA_ANSWER_GROUP_VERSIONS_ALREADY_SHARED_EXCEPTION: '共有中のデータは更新できません',
    ESG_DATA_ALREADY_SHARED_EXCEPTION: '既に共有中の企業に属するユーザーです',
    ESG_DATA_UNANSWERED_SHARE_EXCEPTION: '回答データがないため共有できません',
    ESG_DATA_MAX_SHARE_LIMIT_EXCEPTION: '共有数の上限に達しています',
    ESG_DATA_INVITATION_EXPIRED_EXCEPTION: '共有期限が過ぎています',
    ESG_DATA_USER_ALREADY_REGISTERED_EXCEPTION: '既に登録済みのユーザーです',
    ESG_DATA_OWN_COMPANY_SHARE_EXCEPTION: '自社アカウントに対してESGデータの共有はできません',
    ANSWER_GROUP_INVITATION_ALREADY_EXIT: '@:validation.not_same_sharing_email',
    ANSWER_GROUP_INVITATION_TOKEN_EXPIRED_EXCEPTION: 'パスワードの有効期限が切れました。認証画面に移動します。',
    ANSWER_GROUP_INVITATION_UNAUTHORIZED_EXCEPTION: '回答閲覧用URLのパスワードが確認できませんでした。認証画面に移動します。',
    ANSWER_GROUP_INVITATION_IS_INVALID_EXCEPTION: '該当の調査票またはアカウントが無効になっています。現在は閲覧できません。',
    ANSWER_GROUP_INVITATION_IS_NOT_EXIST_EXCEPTION: '共有が解除されました。現在は閲覧できません。',
    ANSWER_GROUP_INVITATION_WRONG_PASSWORD_EXCEPTION: '@:registration.password.error_linking',
    ANSWER_GROUP_INVITATION_OWN_COMPANY_SHARE_EXCEPTION: '同じアカウントのユーザーには共有することができません',
    BUYER_CREATE_QUESTION_GROUP_LIMIT_EXCEEDED_EXCEPTION: '実施できる調査数の上限に達しています。',
    BUYER_CREATE_QUESTION_GROUP_LOCALE_NAMES_NOT_FOUND_EXCEPTION: '入力に不備のある言語がありました。',
    CAN_NOT_EDIT_BUYER_CREATED_QUESTION_GROUP_EXCEPTION: '調査開始したアンケートの更新はできません。',
    EXPIRED_DATE_IS_NOT_FUTURE_DATE_EXCEPTION: '回答期限を過去の日付で設定することはできません。',
  },
};